export default function generate() {
  const base64 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

  let s = '';
  while (s.length < 5) {
    s += base64[Math.floor(Math.random() * base64.length)];
  }

  return s;
}
